import React, { useEffect } from 'react';
import { Header2 } from '../NavBar/Header2';
import methodimg1 from "../../images/Getinvolved/HeightMeasurement.JPG";
import methodimg2 from "../../images/Getinvolved/NigeriaDataCollection.jpg";
import samplingimg from "../../images/Getinvolved/StandingLongJump.jpeg";
import measuresimg from "../../images/Getinvolved/EYToobox.jpg";
import trainingimg from "../../images/Getinvolved/BalanceMeasurement.jpeg";
import Footer from '../Footer/Footer'
import './Getinvolved.css';
import '../../App.css';
import reveal from '../ScrollAnimation/reveal';

const Getinvolved = () => {
  useEffect(() => {
    document.title = "Get Involved"
  }, []);
  return (
    <>
      <Header2 />
      <div className="getinvolved " >
        <div className='info'>
          <h1 style={{ color: '#494b4d', textAlign: 'center' }}>Get Involved</h1>
          <p>&nbsp;</p>
        </div>
        <div className='load'>
          <p>The SUNRISE study fosters an international community of researchers interested in early childhood movement behaviours.</p><br />
          <p><strong>Interested in taking part?</strong> Please read the information below, then contact the Coordinating Centre to discuss your
            participation at
            <a href='mailto:sunrise-uowcentre@uow.edu.au'> sunrise-uowcentre@uow.edu.au</a></p><br />
          <p>Below, you will find details about what’s involved should you wish to take part in the SUNRISE study.</p>

          <br />
          <section className='section'>
            <div className='method'>
              <div>
                <h2>Methods</h2>
                <p>The SUNRISE study commenced as an international cross-sectional study.
                  The SUNRISE study has a focus on developing countries undergoing a period of rapid urbanisation, with countries involved from each of
                  the four levels of the United Nations HDI (Low, Middle, High, Very High). We expect an over-representation from Asia and Africa,
                  where 90% of the anticipated increase in the global urban population will occur in the next 30 years (United Nations, 2014).</p>
              </div>
            </div>
            <br />
            <div className='method_images'>
              <div className='method_image1' style={{ display: 'flex' }}>
                <figure>
                  <img src={methodimg1} alt='method_img'></img>
                  <figcaption style={{ textAlign: 'center' }}>Height Measurement</figcaption>
                  <figcaption style={{ textAlign: 'center' }}>Data Collection Malaysia</figcaption>
                </figure>
              </div>
              <div className='method_image2' style={{ display: 'flex' }}>
                <figure>
                  <img src={methodimg2} alt='method_img'></img>
                  <figcaption style={{ textAlign: 'center' }}>NIH Toolbox 9 Hole Pegboard assessment</figcaption>
                  <figcaption style={{ textAlign: 'center' }}>Data Collection Nigeria</figcaption>
                </figure>
              </div>
            </div>
          </section>
        </div>
        <br />
        <section className='reveal'>

          <div>
            <h2>Recruitment and Sampling</h2>
            <p>Each country will need to complete a <strong>Pilot</strong> study involving 100 children (50 each from an urban and rural setting) prior to participating
              in the Main study. For the <strong>Main</strong> SUNRISE study, each country will recruit a broadly nationally representative sample children, equally from urban and rural settings. The Coordinating
              Centre team can assist you with sample size calculations for the Main study. These children will be recruited through early childhood
              education (childcare) settings if possible, or other settings depending on what is best suited for each country.</p><br />
          </div>

          <div>
            <div className='sampling'>
              <div>
                <figure style={{ display: 'flex', flexDirection: 'column' }}>
                  <img src={samplingimg} alt='sampling_img'></img>
                  <figcaption style={{ textAlign: 'center' }}>Standing Long Jump - Data Collection Brazil</figcaption>
                </figure>
              </div>
              <div>
                <p>
                  <strong>Pilot study: </strong>
                  Each country will recruit 100 children (50 each from an urban and rural setting). These children will be recruited through early childhood education (childcare)
                  settings if possible, or other settings depending on what is best suited for each country. In countries where children will be exclusively recruited from childcare
                  centres, a maximum of 25 children per centre will be recruited to ensure there is variability within the sample. The sampling frame will comprise a geographical area
                  within reasonable travel distance from the chief investigator’s institution. Each country will need to complete a Pilot study prior to participating in the Main study.
                </p>
                <p>&nbsp;</p>
                <p>
                  <strong>Main study: </strong>
                  Each country will recruit a broadly nationally representative sample with equal representation from urban and rural settings for the regions/states of the
                  country. The Coordinating Centre team can assist you with the selection of sampling frames and sample size calculation. Similar to the Pilot study, a maximum of 25
                  children will be recruited from each childcare centre to ensure there is variability within the sample.
                </p>
              </div>
            </div>

            <p>&nbsp;</p>
            <p>The sampling frame for each country will comprise a geographical area within reasonable travel distance from the chief investigators
              (CIs) institution. If recruitment is conducted through childcare centres, then the primary sampling unit will be the childcare centre.
              The maximum number of children who can be recruited from any one centre will be advised.  In each country, the sample will be stratified
              by urban/rural location and by indicators of socio-economic status to maximize variability within countries (Katzmarzyk et al., 2013).</p>
          </div>
        </section>
        <p>&nbsp;</p>
        <section className='reveal'>
          <div className='measures '>
            <div>
              <h2>Measures</h2>
              <p>Twenty-four-hour movement behaviours (physical activity, sedentary time, and sleep) will be assessed using accelerometry. The budget for
                the study includes a limited pool of accelerometers that will be used across countries. Staff in each country will be trained in how to
                use accelerometers to measure movement behaviours in this age group. Children will be asked to wear an accelerometer continuously
                (including sleeping) for a minimum of five days. Parents/carers will report their child’s use of electronic media, sleep quality, and
                restrained sitting time. Sociodemographic data will be collected from parents/carers using a modified version of the WHO STEPS Survey.</p><br />
            </div>
            <div>
              <figure style={{ display: 'flex', flexDirection: 'column' }}>
                <img src={measuresimg} alt='measures_img'></img>
                <figcaption style={{ textAlign: 'center' }}>Early Years Toolbox App - Papua New Guinea </figcaption>
              </figure>
            </div>
          </div>
          <ul style={{ marginLeft: '20px' }}>
            <li>
              Current secondary outcomes and instruments include:
            </li><br />
            <li>
              Height and weight – measured using standardised procedures (as per WHO protocols),
            </li><br />
            <li>
              Executive Function  – <a href='http://www.eytoolbox.com.au/' target='_blank' rel="noopener noreferrer">Early Years Toolbox</a> translated into various languages, and
            </li><br />
            <li>
              Various established NIH Toolbox motor skills assessments.
            </li><br />
            <p>The Chief Investigator from each country will be mentored through the research process by a Leadership Group member.</p>
          </ul>
        </section>
        <p>&nbsp;</p>
        <section className='reveal'>
          <div className='issues'>
            <h2>Ethical Issues</h2>
            <p>The overarching protocol for the Pilot and Main studies have been approved by the University of Wollongong Human Research Ethics Committee.
              The protocol for each country needs to be approved by the ethics committees at the participating institutions of each Chief
              Investigator. Approval will also be sought from any relevant government departments or organisations who oversee relevant settings
              in different countries. Participant information sheets, consent forms, and questionnaires will be translated and back translated, as
              necessary, into the local language of each country following approved procedures of the local institutions.</p>
          </div>
        </section>
        <p>&nbsp;</p>
        <section className='reveal'>
          <div className='quality'>
            <h3>Quality Assurance of Data Collection, Storage and Management</h3><br />
            <p>This important component of the project will be conducted by the Data Management Coordinator at the SUNRISE Coordinating Centre at the University
              of Wollongong. Comprehensive data guidelines that set out the principles and protocols governing the management, access, use and dissemination of
              the data have been developed. A Data Quality Assurance Plan that describes in detail the methods and procedures to be followed has also been developed.</p>
          </div>
        </section>
        <p>&nbsp;</p>
        <section className='reveal'>
          <div className='agreement'>
            <h3>Collaboration Agreement</h3><br />
            <p>SUNRISE has a Collaboration Agreement that covers Intellectual Property issues, Data Use, Confidentiality, Privacy, Equipment Loan, and
              the roles and responsibilities of each party. The Agreement is to be reviewed by each country’s Legal representative, and executed by
              both the participating country’s authorised representative and the UOW authorised representative, prior to training in each country.
              There is a separate agreement for the Pilot and Main studies.</p><br />
            <p>An Appendix to the SUNRISE Collaboration Agreement is the Publication Policy. This outlines the request for data, authorship, review of
              publications, and data usage for both individual country and collective data for the Pilot and Main studies. The Publication Policy
              includes a data request form.</p>
          </div>
        </section>
        <p>&nbsp;</p>
        <section className='reveal'>
          <div className='training_and_budget'>
            <div>
              <div className='training'>
                <h2>Training of Personnel</h2>
                <p>Training sessions for all country Chief Investigators and key staff will be organised by the Coordinating Centre in advance of data collection
                  in each country. All staff will be certified by trained experts as competent to make the required measurements, which will involve the
                  completion of hands-on training sessions and one-on-one training by experts s, reviewing the protocol manual and videos, and successfully
                  completing on-line exams after  the training sessions.</p>
                <p>&nbsp;</p>
              </div>
              <div className='budget'>
                <h2>Budget</h2>
                <p>Chief Investigators in each country are asked to identify potential funding sources in their own country and to prepare applications
                  for funding under the mentorship of the Leadership Group.</p>
              </div>
            </div>
            <div>
              <figure style={{ display: 'flex', flexDirection: 'column' }}>
                <img src={trainingimg} alt='training_img'></img>
                <figcaption style={{ textAlign: 'center' }}>One Leg Standing Balance</figcaption>
                <figcaption style={{ textAlign: 'center' }}>Data Collection Thailand</figcaption>
              </figure>
            </div>
          </div>
        </section>
        <p>&nbsp;</p>
        <reference>
          <div className='references reveal'>
            <h2>References</h2>
            <ul>
              <li>Okely AD, Reilly JJ, Tremblay MS, et al Cross-sectional examination of 24-hour movement behaviours among 3- and 4-year-old children in urban
                and rural settings in low-income, middle-income and high-income countries: the SUNRISE study protocol.
                BMJ Open 2021;11:e049267. doi: 10.1136/bmjopen-2021-049267</li><br />
              <li>Katzmarzyk PT, Barreira TV, Broyles ST, et al. The international study of childhood obesity, lifestyle and the environment (ISCOLE):
                Design and methods. BMC Public Health. 2013; 13(1):900.</li><br />
              <li>United Nations. World urbanisation prospects, New York, United Nations; 2014,</li>
            </ul>
          </div>
        </reference>
      </div >
      <p>&nbsp;</p>
      <Footer />
    </>
  );
}

export default Getinvolved;
